export default __webpack_public_path__ + "static/media/crypto.16b804fd.png";